/* ============================================================================
   James Wax — Bulk Desk
   PRICING LIVES HERE. Change the ladder below and nothing else.
   Sources for every number:
     1–11 units  ... the 9oz multi-unit ladder already approved and live
                     (_Shared/Etsy Research/Wedding Multi-Unit 2026-08)
     12+ units   ... extended from that ladder; the floor is deliberately held
                     ABOVE Faire wholesale ($12) so a corporate buyer never
                     beats a stockist’s unit price.
     packaging   ... James Wax/Etsy/Gift 档位命名判决 2026-08-28 (net prices)
     retail      ... $17.95, the price a normal customer pays today.
                     Savings are measured against THIS, never a struck list price.
   ============================================================================ */
(function () {
  "use strict";

  /* Two products, two ladders, two minimums. The worker owns these — we ship a
     copy so the page works before GET /pricing lands, and if it never does. */
  /* The gift sets are retail products — nobody orders a hundred Pamper Modes —
     so this page offers the candle, or the candle in a pink box. */
  var JAR_PACKAGING = [
    { id: "none", name: "Candle only", add: 0.00, note: "Bulk-packed, ready to hand out." },
    /* Free from 100. Laguna’s private-label price includes a fitted gift box,
       so charging for ours put us a dollar behind on every quote before the
       candle itself was compared. */
    { id: "pink", name: "Pink box",    add: 1.00, freeFrom: 100,
      note: "The signature box. Arrives ready to gift, and free from 100." }
  ];
  var TIN_PACKAGING = [
    { id: "none", name: "Candle only", add: 0.00, note: "Bulk-packed in trays, ready to set out." },
    { id: "pink", name: "Pink box",    add: 0.50, note: "One small pink box per tin, the same box our Etsy favors ship in." }
  ];

  var PRODUCTS = [
    {
      id: "jar9", name: "9 oz glass jar",
      /* The page used to print the 9 oz spec no matter which product was
         selected, so a tin buyer read 7.2 oz and 40+ hours as a promise. */
      spec: "9 fl oz · 100% soy wax, cotton wick · <b>40+ hour burn</b>",
      specLong: "<b>The 9 oz glass jar:</b> 9 fl oz · 100% soy wax, cotton wick · 40+ hour burn ·",
      blurb: ["The full-size candle.", "Clear glass, brushed gold lid.", "40+ hour burn."],
      retail: 22.00, minQty: 12, packaging: JAR_PACKAGING,
      handle: "bulk-tin-candle-copy",
      /* Flat per-unit price per tier — the only shape Shopify’s automatic
         discounts can express, and therefore the only shape whose cart total
         can match this page. `off` is the per-item amount the discount takes
         off the base price; it is what gets typed into the admin. */
      base: 14.50,
      tiers: [
        { min: 1,    max: 49,   price: 14.50, off: 0.00 },
        { min: 50,   max: 99,   price: 13.50, off: 1.00 },
        { min: 100,  max: 249,  price: 12.50, off: 2.00 },
        { min: 250,  max: 499,  price: 11.50, off: 3.00 },
        { min: 500,  max: 999,  price: 10.50, off: 4.00 },
        { min: 1000, max: null, price:  9.50, off: 5.00 }
      ],
      /* Buyable quantities. Deliberately no size sitting just under a tier
         edge: 99 at $14.50 costs more than 100 at $13.50, and offering it
         would put "buy more, pay less" back on the page. */
      packs: [12, 25, 50, 75, 100, 150, 200, 250, 350, 500, 750, 1000]
    },
    {
      id: "tin4", name: "4 oz travel tin",
      spec: "4 fl oz · 100% soy wax, cotton wick · <b>20 hour burn</b>",
      specLong: "<b>The 4 oz travel tin:</b> 4 fl oz · 100% soy wax, cotton wick · 20 hour burn ·",
      blurb: ["The favour, for tables and welcome bags.", "Gold tin, printed lid label.", "20 hour burn."],
      retail: 7.50, minQty: 50, packaging: TIN_PACKAGING,
      handle: "bulk-tin-candle",
      base: 4.25,
      tiers: [
        { min: 1,    max: 99,   price: 4.25, off: 0.00 },
        { min: 100,  max: 249,  price: 4.15, off: 0.10 },
        { min: 250,  max: 499,  price: 4.05, off: 0.20 },
        { min: 500,  max: 749,  price: 3.95, off: 0.30 },
        { min: 750,  max: 999,  price: 3.85, off: 0.40 },
        { min: 1000, max: null, price: 3.75, off: 0.50 }
      ],
      packs: [50, 75, 100, 150, 200, 250, 300, 400, 500, 750, 1000]
    }
  ];

  /* Four scents plus unscented are always in the building. The other six are
     brought in for the order, which moves the ship date by about a month — so
     `lead` is not decoration, it is the difference between a week and five. */
  var SPECIAL_LEAD_DAYS = 30;
  var SCENTS = [
    { code: "01", name: "Rose + Patchouli" },
    { code: "02", name: "Mimosa + Pineapple" },
    { code: "03", name: "White Tea + Jasmine", note: "best seller" },
    { code: "04", name: "Coconut + Orange" },
    { code: "00", name: "Unscented" },
    { code: "05", name: "Sea Salt + Amber",    lead: SPECIAL_LEAD_DAYS },
    { code: "06", name: "Tomato Leaf + Basil", lead: SPECIAL_LEAD_DAYS },
    { code: "07", name: "Lemon + Honey",       lead: SPECIAL_LEAD_DAYS },
    { code: "08", name: "Peach + Grapefruit",  lead: SPECIAL_LEAD_DAYS },
    { code: "09", name: "Lavender + Sage",     lead: SPECIAL_LEAD_DAYS },
    { code: "10", name: "Fir + Cedar",         lead: SPECIAL_LEAD_DAYS }
  ];
  function scentByCode(c) {
    for (var i = 0; i < SCENTS.length; i++) if (SCENTS[i].code === c) return SCENTS[i];
    return null;
  }
  /* Every scent actually going into this order, single or split. */
  function chosenScents(S) {
    if (!S.mixOn) { var one = scentByCode(S.scentOne); return one ? [one] : []; }
    return SCENTS.filter(function (s) { return (S.mix[s.code] || 0) > 0; });
  }
  function specialChosen(S) {
    return chosenScents(S).filter(function (s) { return s.lead; });
  }


  /* How each one actually smells, in the wording we already use everywhere
     else (James Wax/Etsy 产品描述 2026-08-15.md is the canonical copy across
     all seven shops — usp-detailed.md invents a fifth scent, do not use it).

     Keyed by code and NOT folded into SCENTS, because GET /pricing replaces
     that array wholesale at run time and would carry the notes off with it.

     Some have three movements and some have two. That is the source, not an
     omission: 01 is written "A over B grounded in C" and 04 is written
     "A with B". Nothing here is invented — a fragrance note nobody at the
     bench put in the pour is a lie a customer can smell. */
  /* One photograph per scent, rendered for James Wax in September and then
     never used anywhere. They show the same materials the note lines name,
     which is the whole reason they work here: the picture and the words are
     saying one thing rather than decorating each other. Only the five we pour
     have one — inventing a picture for a scent we buy in would be a picture of
     something nobody has smelled. */
  var SCENT_IMG = {
    "01": "jw-note-01.jpg", "02": "jw-note-02.jpg", "03": "jw-note-03.jpg",
    "04": "jw-note-04.jpg", "05": "jw-note-05.jpg", "06": "jw-note-06.jpg",
    "07": "jw-note-07.jpg", "08": "jw-note-08.jpg", "09": "jw-note-09.jpg",
    "10": "jw-note-10.jpg"
  };
  var CDN = "https://cdn.shopify.com/s/files/1/0571/9539/7326/files/";

  /* The same ten scents, moving. Shopify transcoded them on upload, so these
     are its 480p renditions at 680-880 KB rather than the 2.3 MB we sent it.

     Only the SELECTED card carries a <video>; the other ten stay as stills.
     That is the whole reason this is affordable: picking a scent costs one
     download, not ten, and nothing is fetched until somebody chooses. */
  var SCENT_VID = {
    "01": "610b5f3735e349b4bbdd55e1a4731ebb/610b5f3735e349b4bbdd55e1a4731ebb.SD-480p-1.2Mbps-94303532",
    "02": "0f212de5b1f14bab8c0f3059e5026405/0f212de5b1f14bab8c0f3059e5026405.SD-480p-1.5Mbps-94303533",
    "03": "d8be8cf97c8e43b784d81d1dfc604769/d8be8cf97c8e43b784d81d1dfc604769.SD-480p-1.5Mbps-94303534",
    "04": "e525e6eb1998483d891fca7244423542/e525e6eb1998483d891fca7244423542.SD-480p-1.2Mbps-94303535",
    "05": "e929ca367de44abbbfb64a4c74c64ff2/e929ca367de44abbbfb64a4c74c64ff2.SD-480p-1.5Mbps-94303536",
    "06": "76be1f1fbce1497287ea60ce0d200873/76be1f1fbce1497287ea60ce0d200873.SD-480p-1.5Mbps-94303537",
    "07": "a8c67d02659d4d5198e5c3afea8da774/a8c67d02659d4d5198e5c3afea8da774.SD-480p-1.2Mbps-94303538",
    "08": "d6da5a6e77b946a8a96779bd0e9b18e6/d6da5a6e77b946a8a96779bd0e9b18e6.SD-480p-1.5Mbps-94303539",
    "09": "c6017d16a01f40438590ace3e4f0ed2e/c6017d16a01f40438590ace3e4f0ed2e.SD-480p-1.5Mbps-94303540",
    "10": "c39210540da84068ab8470520d5caaae/c39210540da84068ab8470520d5caaae.SD-480p-1.5Mbps-94303541"
  };
  var VCDN = "https://cdn.shopify.com/videos/c/vp/";
  /* Somebody who has asked their system not to animate things does not want
     ten seconds of drifting fruit either. They keep the still. */
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

  var SCENT_NOTES = {
    "01": [["Opens",        "Basil and grapefruit"],
           ["Settles into", "Rose and magnolia"],
           ["Grounded in",  "Patchouli"]],
    "02": [["Opens",        "Citrus and pineapple"],
           ["Settles into", "Soft florals, amber and vanilla"]],
    "03": [["Opens",        "Mandarin, ginger and bergamot"],
           ["Settles into", "Jasmine and white tea"]],
    "04": [["Opens",        "Citrus and coconut"],
           ["Settles into", "Amber and vanilla"]],
    "00": [["No fragrance oil", "Soy wax and a cotton wick, nothing else"]],
    /* The six we buy in. These come from the oils themselves, recorded when
       the list was derived (_Shared/B2B/faire-winback-2026-09/scents.md) —
       the same CandleScience oils Maren Wells pours, renamed into the two-note
       format we use. Read off the supplier’s own note list, in its order. */
    "05": [["Opens",        "Ocean air and sea salt"],
           ["Settles into", "Freesia"],
           ["Grounded in",  "Amber, tonka and musk"]],
    "06": [["Opens",        "Tomato leaf and lemon peel"],
           ["Settles into", "Basil and thyme"],
           ["Grounded in",  "Moss"]],
    "07": [["Opens",        "Lemon and bergamot"],
           ["Settles into", "Cake and butter"],
           ["Grounded in",  "Honey and tonka"]],
    "08": [["Opens",        "Peach and grapefruit"],
           ["Settles into", "Mango and red currant"],
           ["Grounded in",  "Cedar"]],
    "09": [["Opens",        "Marine and eucalyptus"],
           ["Settles into", "Lavender and sage"],
           ["Grounded in",  "Cedar and cypress"]],
    "10": [["Opens",        "Cypress and lemon peel"],
           ["Settles into", "Evergreen and fir"],
           ["Grounded in",  "Cedar and moss"]]
  };

  var LABEL_TYPES = [
    { id: "catalog", name: "Pick from our catalog",
      note: "Thousands of finished designs: professions, milestones, inside jokes. Tell us which and we’ll send the list." },
    { id: "text", name: "Your words, our label",
      note: "A name, a town, a line only your people would get. Set in the James Wax label style." },
    /* One upload, not two. A logo and a photo were separate options doing the
       same thing, and splitting them meant a wedding customer looking for
       "photo" and a company looking for "logo" each saw a list where half of
       it was addressed to somebody else. */
    { id: "logo", name: "Your artwork on the label",
      note: "A logo, a photo, a drawing. Upload it and we fit it to our label template, then send a digital proof before we pour." }
  ];


  var SHIP_MODES = [
    { id: "one",  name: "One shipment to you", note: "Everything in one box to a single address. Free." },
    { id: "many", name: "Straight to each recipient", note: "Upload your list and we pack, label and ship each one." }
  ];

  /* The packaging add-on is a separate product, and it must stay OUT of every
     bulk discount’s scope: inside it, the box would be discounted and would
     also count toward the quantity threshold that unlocks the candle price. */
  var BOX_HANDLE = "bulk-pink-box";

  /* Above this a run is scheduled rather than shipped from the next batch, so
     the lead time we quote has to change with it. */
  var SCHEDULE_ABOVE = 500;

  var SHEETJS = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";

  function boot(root) {
    if (!root || root.dataset.bkdReady === "1") return;
    root.dataset.bkdReady = "1";

    /* settings come from the section schema so pricing basics are editable
       in the theme editor without touching this file */
    var CFG = { email: "hello@jameswax.com", freeShipOver: 35, perPackageShip: 7.95, quoteAbove: 5000, orderEndpoint: "" };
    var NUMERIC = ["freeShipOver", "perPackageShip", "quoteAbove"];
    try {
      var raw = root.querySelector(".bkd-settings");
      if (raw) {
        var j = JSON.parse(raw.textContent);
        for (var k in j) {
          if (j[k] === null || j[k] === "") continue;
          if (NUMERIC.indexOf(k) !== -1) {
            var v = parseFloat(j[k]);
            if (isFinite(v) && v > 0) CFG[k] = v;   /* a typo in the theme editor keeps the default */
          } else { CFG[k] = j[k]; }
        }
      }
    } catch (e) {}

    var S = {
      step: 0,
      product: "jar9",
      /* No scent chosen. A default here meant step one arrived already
         ticked, so somebody who touched nothing at all could press Next
         straight past the one decision this page exists to take. */
      qty: 24, mixOn: false, mix: {}, scentOne: "",
      labelType: "catalog", labelLine: "", brandName: "", labelNotes: "", logo: null,
      designLink: "", designNote: "",
      pickLater: false, wordsLater: false, artLater: false,
      pack: "none",
      ship: "one", rows: [],
      cName: "", cCo: "", cEmail: "", cPhone: "", cWhen: "",
      address: { address1: "", address2: "", city: "", state: "", zip: "", country: "US" }
    };

    var $ = function (id) { return root.querySelector('[data-bkd="' + id + '"]'); };
    var money = function (n) { return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
    var money0 = function (n) { return "$" + Math.round(n).toLocaleString("en-US"); };
    var esc = function (s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    };

    /* The worker owns the ladder. We ship a copy so the page works before the
       fetch lands (and if it never does), then take the worker’s word for it. */
    function adoptRemote(j) {
      var swap = function (target, incoming) {
        if (!Array.isArray(incoming) || !incoming.length) return;
        target.length = 0;
        incoming.forEach(function (x) { target.push(x); });
      };
      swap(PRODUCTS, j.products); swap(SCENTS, j.scents);
      swap(LABEL_TYPES, j.labelTypes);
      /* both are built from SCENTS, so both have to be rebuilt after it is
         replaced or the page keeps showing the shipped copy of the list */
      if (typeof renderScentSelect === "function") renderScentSelect();
      renderScentCards();
      renderHeroLadder();
      renderMeterSeg();
      ["freeShipOver", "perPackageShip", "quoteAbove"].forEach(function (k) {
        var v = parseFloat(j[k]);
        if (isFinite(v) && v > 0) CFG[k] = v;
      });
    }

    /* ---------------- pricing ---------------- */
    function prod() {
      for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].id === S.product) return PRODUCTS[i];
      return PRODUCTS[0];
    }
    /* One flat rate across a whole tier — the shape Shopify’s automatic
       discounts can express, and therefore the only shape whose cart total can
       match what this page quotes. Quantities are restricted to `packs`, none
       of which sits just under a tier edge, so nothing we sell ever costs more
       than a larger order. */
    function tierFor(p, q) {
      for (var i = 0; i < p.tiers.length; i++) {
        var t = p.tiers[i];
        if (q >= t.min && (t.max === null || q <= t.max)) return t;
      }
      return p.tiers[p.tiers.length - 1];
    }
    /* Flat tiers mean the quantities just under a tier edge cost MORE than the
       edge itself — 96 jars is $1,392 against $1,350 for 100. Rather than
       refuse those quantities, give the buyer the cheaper, larger order: they
       pay less and get more candles. Everywhere else the number they typed is
       the number they get, so any quantity is orderable and the total never
       falls as it grows. */
    function effectiveQty(p, q, pk) {
      /* Compare what the buyer actually PAYS, packaging included, at every
         quantity worth considering. Two things move with quantity: the tier
         price and whether the box is free. Ignoring the box upgraded people
         into paying more; assuming a fixed box price would miss the threshold. */
      function totalAt(n) { return n * (tierFor(p, n).price + (pk ? packAdd(pk, n) : 0)); }
      var best = q, bestTotal = totalAt(q);
      var stops = p.tiers.map(function (t) { return t.min; });
      if (pk && pk.freeFrom) stops.push(pk.freeFrom);
      stops.forEach(function (n) {
        if (n <= q) return;
        var cost = totalAt(n);
        if (cost < bestTotal - 0.0001) { bestTotal = cost; best = n; }
      });
      return best;
    }
    /* One rate for the whole order — the same arithmetic Shopify’s discount
       engine does, which is the point of the model. */
    function priceCandles(p, q) {
      var t = tierFor(p, q);
      return { total: t.price * q, tier: t, avg: t.price };
    }
    function labelType() {
      for (var i = 0; i < LABEL_TYPES.length; i++) if (LABEL_TYPES[i].id === S.labelType) return LABEL_TYPES[i];
      return { id: S.labelType, name: S.labelType, note: "" };
    }
    function packFor(p, id) {
      for (var i = 0; i < p.packaging.length; i++) if (p.packaging[i].id === id) return p.packaging[i];
      return p.packaging[0];
    }
    /* What packaging costs at THIS quantity. Not a constant any more: the box
       is free past a threshold, and the upgrade maths has to know that or it
       compares the wrong totals. */
    function packAdd(pk, q) {
      return (pk.freeFrom && q >= pk.freeFrom) ? 0 : pk.add;
    }
    function minQty() { return prod().minQty; }
    function retail() { return prod().retail; }

    function compute() {
      var P = prod();
      var asked = Math.max(P.minQty, Math.floor(S.qty || P.minQty));
      var pk = packFor(P, S.pack);
      var q = effectiveQty(P, asked, pk);
      var priced = priceCandles(P, q);
      var tier = tierFor(P, q), byQuote = q > CFG.quoteAbove, unit = byQuote ? null : tier.price;
      var candles = byQuote ? null : priced.total, packCost = packAdd(pk, q) * q;

      var goodsPre = (byQuote ? 0 : unit * q) + packAdd(pk, q) * q;
      var ship = 0, shipNote = "one shipment to you", paidPkgs = 0, shipUnknown = false;
      if (S.ship !== "many" && !byQuote && goodsPre < CFG.freeShipOver) {
        ship = CFG.perPackageShip;                       /* small orders do not clear the threshold */
        shipNote = "free over " + money0(CFG.freeShipOver);
      }
      if (S.ship === "many") {
        /* Every recipient is its own parcel with its own label and postage, so
           the free-over-$35 threshold does not apply here — that one covers a
           single box coming to you. */
        if (S.rows.length) {
          paidPkgs = S.rows.length;
          ship = paidPkgs * CFG.perPackageShip;
          shipNote = paidPkgs + " packages at " + money(CFG.perPackageShip) + " each";
        } else {
          /* No list yet, so postage is genuinely unknown. Leaving ship at 0 and
             letting the summary print "Free" told buyers the opposite of the
             truth: per-recipient postage is the biggest line in a split order. */
          shipNote = "add your list and we price each parcel";
          shipUnknown = true;
        }
      }

      var goods = byQuote ? null : candles + packCost;
      var total = byQuote ? null : goods + ship;
      var retailGoods = P.retail * q + packCost;

      return {
        q: q, asked: asked, bumped: q > asked, tier: tier, byQuote: byQuote, unit: unit, pk: pk,
        candles: candles, packCost: packCost,
        ship: ship, shipNote: shipNote, paidPkgs: paidPkgs, shipUnknown: shipUnknown,
        goods: goods, total: total,
        nextTier: P.tiers.filter(function (t) { return t.min > q; })[0] || null,
        perCandle: byQuote ? null : total / q,
        saved: byQuote ? null : retailGoods - goods,
        savedPct: byQuote ? null : (P.retail - unit) / P.retail * 100,
        P: P
      };
    }

    /* The smallest pack that costs less per candle than the one they are on.
       Skipping the packs inside the same tier keeps the nudge honest — going
       from 100 to 150 changes nothing about the price each. */
    function ahead(c) {
      var packs = c.P.packs;
      for (var i = 0; i < packs.length; i++) {
        var at = packs[i];
        if (at <= c.q) continue;
        var each = tierFor(c.P, at).price;
        if (each >= c.unit - 0.005) continue;
        return { at: at, each: each, save: c.unit - each, more: at - c.q };
      }
      return null;
    }

    /* ---------------- render ---------------- */
    /* One rung per tier. The price on it is flat across the whole tier, so it
       is exactly what a buyer at any quantity inside that tier pays — no
       averaging, nothing to add up. Clicking jumps to the smallest pack that
       reaches the tier. */
    function renderLadder(c) {
      var T = c.P.tiers, cur = tierFor(c.P, c.q);
      var prices = T.map(function (t) { return t.price; });
      var hi = Math.max.apply(null, prices), lo = Math.min.apply(null, prices);
      $("ladder").innerHTML = T.map(function (t) {
        /* 44 was the floor and the content inside a bar needs 49, so the
           cheapest tier — the one everybody scrolls over to see — had its
           "% off" sliced off at the bottom edge. */
        var h = 64 + (hi === lo ? 38 : ((t.price - lo) / (hi - lo)) * 76);
        var off = Math.round((c.P.retail - t.price) / c.P.retail * 100);
        var isCur = t === cur;
        var done = t.max !== null && c.q > t.max;
        var entry = Math.max(t.min, c.P.minQty);
        var label = t.max === null
          ? entry.toLocaleString() + "+"
          : entry.toLocaleString() + "–" + t.max.toLocaleString();
        return '<button type="button" class="bkd-rung' + (isCur ? " is-current" : "") +
          (done ? " is-past" : "") + '" data-q="' + entry + '"' + (isCur ? ' aria-current="true"' : "") + '>' +
          '<span class="bkd-rung-name">' + label + "</span>" +
          '<span class="bkd-rung-bar" style="height:' + h.toFixed(0) + 'px">' +
            '<span class="bkd-rung-price">' + money(t.price) + "</span>" +
            '<span class="bkd-rung-off">' + off + "% off</span></span>" +
          '<span class="bkd-rung-qty">each</span></button>';
      }).join("");
      Array.prototype.forEach.call($("ladder").querySelectorAll(".bkd-rung"), function (btn) {
        btn.onclick = function () { setQty(+btn.dataset.q); };
      });
    }

    function renderNudge(c) {
      var el = $("nudge");
      if (c.byQuote) {
        el.innerHTML = '<div class="bkd-nudge is-top"><div class="bkd-nudge-body">' +
          '<div class="bkd-nudge-lead">You are past the ladder. This one we price by hand</div>' +
          '<div class="bkd-nudge-sub">At ' + c.q.toLocaleString() + " candles we build a run schedule around " +
          "your date and quote freight properly. Send the spec below and we come back with a firm number.</div></div></div>";
        return;
      }
      var nx = ahead(c);
      if (!nx) {
        el.innerHTML = '<div class="bkd-nudge is-free"><div class="bkd-nudge-body">' +
          '<div class="bkd-nudge-lead">This is the best price we publish</div>' +
          '<div class="bkd-nudge-sub">' + money(c.unit) + " a candle, " + Math.round(c.savedPct) +
          "% off our normal price. Nothing further to unlock.</div></div></div>";
        return;
      }
      el.innerHTML = '<div class="bkd-nudge"><div class="bkd-nudge-body">' +
        '<div class="bkd-nudge-lead">' + nx.at.toLocaleString() + " candles works out to " +
        money(nx.each) + " each</div>" +
        '<div class="bkd-nudge-sub">That is <b>' + money(nx.save) + " less per candle</b> than the " +
        money(c.unit) + " you are paying at " + c.q.toLocaleString() + ". " +
        nx.more.toLocaleString() + " more candles for " +
        money(priceCandles(c.P, nx.at).total - c.candles) + ".</div></div>" +
        '<button class="bkd-nudge-btn" type="button" data-take="' + nx.at + '">Make it ' +
        nx.at.toLocaleString() + "</button></div>";
      var tk = el.querySelector("[data-take]");
      if (tk) tk.onclick = function () { setQty(+tk.dataset.take); };
    }

    /* Say plainly when we are sending more than they asked for. Silently
       changing someone’s quantity is the kind of thing that reads as a bug
       when they spot it on the invoice. */
    function renderBump(c) {
      var el = $("bumpNote");
      /* A run this size is scheduled, not shipped from the next batch. Someone
         paying for a thousand candles must not read "3 to 5 business days" and
         plan a date around it. */
      if (!c.bumped && c.q > SCHEDULE_ABOVE && !c.byQuote) {
        el.classList.remove("bkd-hide");
        el.innerHTML = "<b>" + c.q.toLocaleString() + " candles is a production run.</b> " +
          "We still take the order here, and we will come back within one business day to agree a " +
          "date before anything is made. Proof first either way.";
        return;
      }
      if (!c.bumped || c.byQuote) { el.classList.add("bkd-hide"); return; }
      var askedTotal = c.asked * tierFor(c.P, c.asked).price;
      el.classList.remove("bkd-hide");
      el.innerHTML = "<b>" + c.q.toLocaleString() + " candles costs less than " +
        c.asked.toLocaleString() + ".</b> At " + c.asked.toLocaleString() + " you would pay " +
        money(askedTotal) + "; at " + c.q.toLocaleString() + " the price drops to " +
        money(c.P.retail === null ? 0 : tierFor(c.P, c.q).price) + " each and the whole lot is " +
        money(c.candles) + ". We are sending <b>" + c.q.toLocaleString() + "</b>, " +
        (c.q - c.asked).toLocaleString() + " more candles for " + money(askedTotal - c.candles) + " less.";
    }

    /* The phone bar carries whatever the current step is asking for: keep
       moving while there are steps left, then the real action at the end. */
    function renderBar(c) {
      $("barTotal").textContent = c.byQuote ? "By quote" : money(c.total);
      $("barNote").textContent = c.byQuote
        ? "we price this one by hand"
        : c.q.toLocaleString() + " candles · " + money(c.perCandle) + " each delivered";
      var last = S.step === STEP_NAMES.length - 1;
      var btn = $("barAction");
      var gap = firstGap();
      /* This bar is the only thing a phone shows, so it is the button that
         actually gets pressed — and it was calling goStep straight, walking
         over every empty step while the Next inside the step and the cart
         button both refused. Same gate, same words as the rail. */
      btn.textContent = !last ? "Next"
        : (gap && !c.byQuote && S.ship === "one") ? "Finish " + STEP_NAMES[gap.step].toLowerCase()
        : ($("payBtn").classList.contains("bkd-hide") ? "Send quote" : "Add to cart");
      btn.onclick = function () {
        if (!last) {
          var g = stepGap(S.step);
          if (g) { showGap(g); return; }
          return tryStep(S.step + 1);
        }
        /* One behaviour in one place: the rail already knows how to refuse,
           where to jump, and when it is a cart or a quote. */
        $("railSend").click();
      };
    }

    /* NOT renderSpec. There is already a renderSpec further down that builds
       the plain-text order spec, and a second declaration by that name
       silently replaced it — every render() then called the text builder with
       a product where it expected the calc, threw on the first property, and
       took the whole quote rail down with it. Named for what it does. */
    function renderSpecLine(P) {
      var t = $("trustSpec"), f = $("fineSpec");
      var tail = " poured, labeled and packed by us in Orange, California.";
      if (t && P.spec) t.innerHTML = P.spec;
      if (f && P.specLong) f.innerHTML = P.specLong + tail;
    }

    function renderRail(c) {
      renderSpecLine(c.P);
      /* "$13.50 each · $13.50 each delivered" is one number said twice; only
         say the second when shipping actually moves it. */
      $("stage").textContent = c.byQuote
        ? "priced by hand"
        : c.q.toLocaleString() + " candles · " + money(c.unit) + " each" +
          (c.shipUnknown ? " · postage still to price"
            : Math.abs(c.perCandle - c.unit) > 0.005 ? " · " + money(c.perCandle) + " delivered" : ", shipped free");
      if (c.byQuote) {
        $("saveAmt").textContent = "By quote";
        $("savePct").textContent = "";
        $("saveSub").textContent = "Orders this size get hand-priced, usually better than the bottom of the ladder.";
      } else {
        $("saveAmt").textContent = money0(c.saved);
        $("savePct").textContent = "· " + Math.round(c.savedPct) + "% off";
        $("saveSub").textContent = "Estimate only. Nothing on this page charges you.";
      }

      /* One line, not the band-by-band breakdown — that is our accounting, and
         a buyer reading "50 at $4.50, 50 at $4.00, 150 at $3.85" has to add it
         up themselves to learn the one number they came for. */
      var L = [{
        k: "<b>" + c.q.toLocaleString() + " candles</b>" + (c.byQuote ? "" : " at " + money(c.unit) + " each"),
        v: c.byQuote ? "By quote" : money(c.candles)
      }];
      if (!c.byQuote) L.push({ k: "was " + money(c.P.retail) + " each", v: money(c.P.retail * c.q), cls: "strike" });
      if (c.pk.id !== "none") {
        var boxFree = packAdd(c.pk, c.q) === 0;
        L.push({ k: "<b>" + esc(c.pk.name) + "</b>" +
                    (boxFree ? " included at this quantity" : " at " + money(c.pk.add) + " each"),
                 v: boxFree ? "Free" : money(c.packCost), cls: boxFree ? "free" : "" });
      }
      L.push({ k: "<b>Shipping</b> " + esc(c.shipNote),
               v: c.shipUnknown ? "To be quoted" : c.ship === 0 ? "Free" : money(c.ship),
               cls: (!c.shipUnknown && c.ship === 0) ? "free" : "" });

      $("qlines").innerHTML = L.map(function (l) {
        return '<div class="bkd-qline ' + (l.cls === "strike" ? "strike" : "") + '"><span class="lbl">' + l.k +
          '</span><span class="amt ' + (l.cls === "free" ? "free" : "") + '">' + l.v + "</span></div>";
      }).join("");

      $("grand").textContent = c.byQuote ? "By quote" : money(c.total);
      /* The headline number is only a total when every line is in it. With
         per-recipient postage still unpriced it is a subtotal, and saying so is
         the difference between an estimate and a wrong number. */
      var eyebrow = $("qeyebrow");
      if (eyebrow) eyebrow.textContent = c.byQuote ? "Priced by hand"
        : c.shipUnknown ? "Candles and packaging only" : "Estimated total";
      /* A special-order scent moves the ship date by about a month. Saying
         "3 to 5 business days" underneath that choice would be the single most
         damaging sentence on the page, so the whole line changes. */
      var sp = specialChosen(S);
      $("qfoot").innerHTML = c.byQuote
        ? "Send the spec and we come back with a firm total and a run date."
        : sp.length
          ? "Digital proof in 1 business day. <b>" + esc(sp.map(function (x) { return x.name; }).join(" and ")) +
            (sp.length > 1 ? " are special-order scents" : " is a special-order scent") +
            "</b>, we bring it in for this run, so expect to ship about <b>" + SPECIAL_LEAD_DAYS +
            " days</b> after you approve, not 3 to 5. Pick a stocked scent if your date is tight."
          : (c.q > SCHEDULE_ABOVE
              ? "Digital proof in 1 business day. A run this size we schedule with you, so we agree on a date before anything is made."
              : "Digital proof in 1 business day, then 3 to 5 business days to make and ship once you approve it.");
    }

    var SPEC = "";
    function renderSpec(c) {
      var P = [];
      P.push("JAMES WAX BULK ORDER SPEC");
      P.push("Generated " + new Date().toLocaleString("en-US"));
      P.push("");
      P.push("WHO");
      P.push("  Name      " + (S.cName || "-"));
      P.push("  Company   " + (S.cCo || "-"));
      P.push("  Email     " + (S.cEmail || "-"));
      P.push("  Phone     " + (S.cPhone || "-"));
      P.push("  Needed    " + (S.cWhen || "-"));
      P.push("");
      P.push("ORDER");
      P.push("  Candle    " + c.P.name);
      P.push("  Quantity  " + c.q.toLocaleString());
      if (c.byQuote) { P.push("  Pricing   by hand"); }
      else {
        P.push("  Pricing   " + money(c.unit) + " per candle, " +
               Math.round(c.savedPct) + "% off " + money(c.P.retail));
      }
      if (S.mixOn) {
        P.push("  Scents    split:");
        SCENTS.forEach(function (s) { var n = S.mix[s.code] || 0; if (n) P.push("              " + n + " × " + s.code + " " + s.name); });
      } else {
        var so = scentByCode(S.scentOne);
        /* Reachable with nothing chosen: the quote button does not go through
           the step gate when the order is going to many addresses. Saying so
           in the quote beats throwing inside render(). */
        P.push("  Scent     " + (so ? so.code + " " + so.name + " (whole order)"
                                   : "not chosen yet"));
      }
      /* The worker’s config replaces this list at run time, so an id the page
         knows and the worker does not would land here as undefined. That threw
         inside render() and took the whole page down with it — every panel
         after this line stopped updating. */
      var lt = labelType();
      P.push("  Label     " + lt.name);
      if (S.labelType === "text" && S.labelLine) P.push('             text: "' + S.labelLine + '"');
      if (S.labelType === "logo") {
        P.push("             brand: " + (S.brandName || "-"));
        if (S.labelNotes) P.push("             notes: " + S.labelNotes);
        P.push("             artwork: " + (S.logo ? S.logo.name + " (" + Math.round(S.logo.size / 1024) + " KB, attach to your reply)" : "not attached yet"));
      }
      P.push("  Packaging " + c.pk.name +
             (c.pk.id === "none" ? "" : packAdd(c.pk, c.q) ? " (+" + money(c.pk.add) + " each)" : " (included)"));
      P.push("");
      P.push("SHIPPING");
      if (S.ship === "one") {
        P.push("  One shipment to:");
        var A = S.address || {};
        [S.cCo, A.address1, A.address2, [A.city, A.state, A.zip].filter(Boolean).join(", ")]
          .filter(Boolean).forEach(function (l) { P.push("    " + l); });
        if (!A.address1) P.push("    (no address yet)");
      } else {
        P.push("  Direct to " + S.rows.length + " recipients");
        P.push("  " + c.shipNote);
        S.rows.slice(0, 200).forEach(function (r, i) {
          P.push("    " + String(i + 1) + ". " +
            [r.name, r.company, r.addr, r.city, r.state, r.zip].filter(Boolean).join(", ") +
            "  ×" + (r.qty || 1) + (r.scent ? "  scent " + r.scent : "") + (r.label ? '  label "' + r.label + '"' : ""));
        });
        if (S.rows.length > 200) P.push("    … " + (S.rows.length - 200) + " more in the attached CSV");
      }
      P.push("");
      P.push("ESTIMATE");
      if (c.byQuote) { P.push("  Priced by hand, please quote."); }
      else {
        P.push("  Candles   " + money(c.candles));
        if (c.packCost) P.push("  Packaging " + money(c.packCost));
        P.push("  Shipping  " + (c.ship ? money(c.ship) : "free"));
        P.push("  TOTAL     " + money(c.total) + "   (" + money(c.perCandle) + " per candle delivered)");
        P.push("  Saved     " + money(c.saved) + " against " + money(c.P.retail) + " each");
      }
      SPEC = P.join("\n");
      $("spec").textContent = SPEC;
    }

    function render() {
      var c = compute();
      /* The lede said "12 candles minimum" in hardcoded text, so selecting the
         4 oz — which starts at 50 — left a false number at the top of the page. */
      if ($("ledeMin"))  $("ledeMin").textContent  = prod().minQty.toLocaleString();
      if ($("stackMin")) $("stackMin").textContent = prod().minQty.toLocaleString();
      renderMeter(c); renderStepNav(); renderPackPrices();
      renderLadder(c); renderNudge(c); renderRail(c); renderSpec(c); renderBump(c); renderBar(c);
      mark("packOpts", S.pack);
      mark("labelOpts", S.labelType); mark("shipOpts", S.ship);
      /* one place decides which label panel is open, so it is right on first
         paint too — these used to be set only when something changed */
      $("labelPick").classList.toggle("bkd-hide", S.labelType !== "catalog");
      $("labelText").classList.toggle("bkd-hide", S.labelType !== "text");
      $("labelLogo").classList.toggle("bkd-hide", S.labelType !== "logo");
      $("logoBrand").classList.toggle("bkd-hide", S.labelType !== "logo");

      var below = Math.floor(S.qty || 0) < c.P.minQty;
      $("minNote").classList.toggle("bkd-hide", !below);
      if (below) {
        $("minNote").innerHTML = "<b>" + esc(c.P.name) + " orders start at " + c.P.minQty + " candles.</b> " +
          "Fewer than that and our ordinary listing is a better deal for you. " +
          "prices below show the " + c.P.minQty + "-candle rate.";
      }


      var can = payable(c), why = whyNotPayable(c);
      $("payBtn").classList.toggle("bkd-hide", !can);
      $("payBtn").textContent = can ? "Add to cart " + money(c.total) : "Add to cart";
      $("sendBtn").classList.toggle("primary", !can);
      $("sendBtn").textContent = can ? "Email this quote instead" : "Open an email with this quote";
      var gap = firstGap();
      $("railSend").textContent = can ? "Add to cart · " + money(c.total)
        : (gap && !c.byQuote && S.ship === "one")
          ? "Finish " + STEP_NAMES[gap.step].toLowerCase() + " \u2192"
          : "Send this quote";
      if (why) { showPayNote(why, false); } else { $("payNote").classList.add("bkd-hide"); }

      /* One line, under whichever step you are standing on, naming what that
         step still owes. Each step has its own so it appears where the empty
         box is rather than in a corner somewhere. */
      ["gap0", "gap1", "gap2", "gap3"].forEach(function (id, i) {
        var el = $(id);
        if (!el) return;
        var g = stepGap(i);
        el.classList.toggle("bkd-hide", !g);
        if (g) el.innerHTML = "<b>We need " + esc(g.what) + "</b> before this order can go in the cart.";
      });
    }
    function mark(host, val) {
      Array.prototype.forEach.call($(host).querySelectorAll(".bkd-opt"), function (o) {
        o.classList.toggle("on", o.dataset.v === val);
      });
    }
    function setQty(n) {
      var P = prod();
      S.qty = Math.max(P.minQty, Math.floor(n || P.minQty));
      if ($("qty")) $("qty").value = S.qty;
      if ($("meterQty") && document.activeElement !== $("meterQty")) $("meterQty").value = S.qty;
      /* Only re-spread a split they have actually made. Re-spreading an empty
         one would fill the answer in behind them, which is the whole bug. */
      if (S.mixOn && mixTotal() > 0) spreadMix(); else if (S.mixOn) tally();
      render();
    }

    /* ---------------- build controls ---------------- */

    /* Which candle. Two products with different minimums, ladders and
       packaging, so switching rebuilds the quantity controls under it. */
    function renderProductPicker() {
      if (!$("productOpts")) return;          /* the meter carries the switch now */
      $("productOpts").innerHTML = PRODUCTS.map(function (p) {
        return '<label class="bkd-opt" data-v="' + p.id + '"><input type="radio" name="bkd-prod" value="' +
          p.id + '"' + (S.product === p.id ? " checked" : "") + '><span class="bkd-opt-txt">' +
          '<span class="bkd-opt-name">' + esc(p.name) +
          /* The price they will actually be quoted, not the 1,000-unit floor.
             "from $11.00" against a $15.25 minimum order is a number almost
             nobody pays, shown first. */
          '<span class="bkd-opt-price">' + money(tierFor(p, p.minQty).price) + " each</span></span>" +
          /* Fixed rows so the two tiles are the same height. A two-line card
             beside a three-line one made the shorter one look like less. */
          '<span class="bkd-opt-note">' +
            /* Never assume the worker’s copy has the shape this page expects;
               a string here used to take the whole render down. */
            (Array.isArray(p.blurb) ? p.blurb : [String(p.blurb || "")])
              .map(function (l) { return "<span>" + esc(l) + "</span>"; }).join("") +
          "</span></span></label>";
      }).join("");
      Array.prototype.forEach.call($("productOpts").querySelectorAll("input"), function (i) {
        i.onchange = function () { switchProduct(i.value); };
      });
    }

    function switchProduct(id) {
      /* the hero strip and the meter both show the selected product */
      setTimeout(function () { renderHeroLadder(); renderMeterSeg(); }, 0);
      S.product = id;
      var P = prod();
      /* the gift boxes only exist on the jar — never carry a dead id across */
      if (!P.packaging.some(function (x) { return x.id === S.pack; })) S.pack = P.packaging[0].id;
      S.qty = Math.max(P.minQty, Math.floor(S.qty || P.minQty));
      [$("qty"), $("meterQty")].forEach(function (el) {
        if (!el) return;
        if (document.activeElement !== el) el.value = S.qty;
        el.setAttribute("min", P.minQty);
      });
      if ($("qtyMin")) $("qtyMin").textContent = "(" + P.minQty + " minimum)";
      renderChips(); renderPackaging();
      loadVariants(P.handle);
      if (S.mixOn && mixTotal() > 0) spreadMix(); else if (S.mixOn) tally();
      render();
    }

    /* Quick picks: the quantity that first reaches each tier, so every chip
       actually changes the price. The rest of the packs live in the dropdown. */
    function renderChips() {
      var P = prod(), seen = [];
      P.tiers.forEach(function (t) {
        var at = Math.max(t.min, P.minQty);
        if (seen.indexOf(at) === -1) seen.push(at);
      });
      $("chips").innerHTML = seen.map(function (n) {
        return '<button class="bkd-chip" type="button" data-q="' + n + '">' + n.toLocaleString() + "</button>";
      }).join("");
      Array.prototype.forEach.call($("chips").querySelectorAll(".bkd-chip"), function (b) {
        b.onclick = function () { setQty(+b.dataset.q); };
      });
    }

    function renderPackaging() {
      optList("packOpts", prod().packaging, "bkd-pk",
        function () { return S.pack; }, function (v) { S.pack = v; },
        function (it) { return packAdd(it, askedQty()); });
      $("packWrap").classList.toggle("bkd-hide", prod().packaging.length < 2);
    }
    /* Updated in place on every render rather than rebuilding the list, so the
       badge follows the quantity without the radios being torn out from under
       whoever is using them. */
    function renderPackPrices() {
      var P = prod(), qn = askedQty();
      Array.prototype.forEach.call($("packOpts").querySelectorAll(".bkd-opt"), function (o) {
        var it = packFor(P, o.dataset.v), el = o.querySelector(".bkd-opt-price");
        if (!it || !el) return;
        var add = packAdd(it, qn);
        el.textContent = add === 0 ? "included" : "+" + money(add) + " each";
        el.classList.toggle("free", add === 0);
      });
    }
    /* The step-one quantity box was removed when its step folded into the
       meter. Everything that spoke to it is guarded rather than deleted: the
       same controls may come back on a narrower layout. */
    if ($("qty")) $("qty").oninput = function (e) { S.qty = Math.floor(+e.target.value || 0); render(); };
    /* let them type freely, then lift to the minimum when they leave the box */
    if ($("qty")) $("qty").onchange = function () { setQty(S.qty); };

    /* Rebuildable, because GET /pricing can replace SCENTS after this runs.
       It used to be written once at boot, which is how the page spent a week
       offering eleven scents from a list that only held five. */
    function renderScentSelect() {
      $("scentOne").innerHTML = '<option value="">Choose a scent</option>' + SCENTS.map(function (s) {
        return '<option value="' + s.code + '">' + s.code + " · " + esc(s.name) +
          (s.lead ? ", special order, +" + s.lead + " days" : (s.note ? " (" + s.note + ")" : "")) + "</option>";
      }).join("");
      ["pickLater", "wordsLater", "artLater"].forEach(function (k) {
        if ($(k)) $(k).checked = !!S[k];
      });
      $("scentOne").value = S.scentOne;
    }
    renderScentSelect();
    renderScentCards();
    renderHeroLadder();
    renderMeterSeg();
    if ($("meterQty")) {
      $("meterQty").oninput   = function (e) { S.qty = Math.max(0, Math.floor(+e.target.value || 0)); render(); };
      $("meterQty").onchange  = function () { setQty(S.qty); };
    }
    $("scentOne").onchange = function (e) {
      S.scentOne = e.target.value; renderScentCards(); renderScentWarn(); render();
    };

    $("mix").innerHTML = SCENTS.map(function (s) {
      return '<div class="bkd-mix-row' + (s.lead ? " special" : "") + '"><span class="nm">' + esc(s.name) +
        "<em>Scent " + s.code + (s.lead ? " · special order, +" + s.lead + " days" : (s.note ? " · " + s.note : "")) +
        '</em></span><input type="number" min="0" step="1" value="0" data-c="' +
        s.code + '" inputmode="numeric" aria-label="' + esc(s.name) + ' quantity"></div>';
    }).join("");
    function mixTotal() { var t = 0; for (var k in S.mix) t += (+S.mix[k] || 0); return t; }
    function spreadMix() {
      /* Spread across the in-stock scents only. Seeding the special-order six
         would quietly add a month to an order the buyer never asked to slow
         down; they can still type a number into one deliberately. */
      var stock = SCENTS.filter(function (s) { return !s.lead; });
      var per = Math.floor(S.qty / stock.length), left = S.qty;
      SCENTS.forEach(function (s) { S.mix[s.code] = 0; });
      stock.forEach(function (s, i) { var v = i === stock.length - 1 ? left : per; S.mix[s.code] = v; left -= v; });
      Array.prototype.forEach.call($("mix").querySelectorAll("input"), function (i) { i.value = S.mix[i.dataset.c] || 0; });
      tally();
    }
    function tally() {
      var t = mixTotal(), off = t !== S.qty;
      $("tally").className = "bkd-tally" + (off ? " bad" : "");
      $("tally").textContent = off
        ? t.toLocaleString() + " assigned of " + S.qty.toLocaleString() + ", " +
          (t < S.qty ? (S.qty - t).toLocaleString() + " still to place" : (t - S.qty).toLocaleString() + " too many")
        : "All " + S.qty.toLocaleString() + " candles assigned.";
    }
    Array.prototype.forEach.call($("mix").querySelectorAll("input"), function (i) {
      i.oninput = function () { S.mix[i.dataset.c] = Math.max(0, Math.floor(+i.value || 0)); tally(); renderScentWarn(); };
    });

    /* The scent step used to be a <select>. Somebody choosing the smell two
       hundred people will carry home was being handed the same control as a
       state field. Cards, with what each one actually does — which is also
       the only part of this page a customer can want rather than configure.
       The <select> stays underneath as the form value and for screen readers;
       these set it. */

    /* The first screen had a heading, a paragraph and then a form. Nothing to
       look at and nothing to want. This is the one thing the page does that
       nobody we compete with does — the number falls as the order grows — and
       it was buried three screens down, under the control that moves it.
       Rendered from the ladder rather than typed, so it cannot drift. */

    /* The meter. Reads the same compute() everything else reads, so it cannot
       disagree with the rail or the ladder — there is one number and three
       places showing it. Its quantity box and the one in step one are two
       views of S.qty; whichever is typed into, both redraw. */
    function renderMeterSeg() {
      var host = $("meterSeg");
      if (!host) return;
      host.innerHTML = PRODUCTS.map(function (p) {
        return '<button type="button" data-v="' + p.id + '" role="radio" aria-checked="' +
          (S.product === p.id ? "true" : "false") + '">' + esc(p.name) +
          '<i>from ' + p.minQty + '</i></button>';
      }).join("");
      Array.prototype.forEach.call(host.querySelectorAll("[data-v]"), function (b) {
        b.onclick = function () { if (S.product !== b.dataset.v) switchProduct(b.dataset.v); };
      });
    }

    /* Two boxes, one number. Whichever is being typed into keeps its own
       text — writing S.qty back into the focused field would fight the
       caret — and the other follows on the same render. */
    function syncQty(c) {
      [$("meterQty"), $("qty")].forEach(function (el) {
        if (!el) return;
        if (document.activeElement !== el) el.value = S.qty;
        el.min = c.P.minQty;
      });
    }

    function renderMeter(c) {
      syncQty(c);
      var u = $("meterUnit");
      if (u) u.innerHTML = c.byQuote ? "by hand"
        : '<sup>$</sup>' + money(c.unit).replace("$", "");
      var t = $("meterTotal");
      if (t) t.innerHTML = c.byQuote ? "Priced by hand"
        : c.shipUnknown ? money(c.goods) + ' <i>plus postage</i>'
        : money(c.total) + (c.ship === 0 ? ' <i>delivered</i>' : '');
      var sub = $("meterSub");
      if (sub) {
        var bits = [];
        if (!c.byQuote && c.ship === 0 && !c.shipUnknown) bits.push("Free shipping to one address");
        if (c.shipUnknown) bits.push("Postage priced per parcel once you add the list");
        if (c.saved > 0) bits.push("<b>" + money(c.saved) + "</b> under retail");
        if (c.nextTier) bits.push("next tier at <b>" + c.nextTier.min.toLocaleString() +
          "</b> for " + money(c.nextTier.price));
        sub.innerHTML = bits.join(" · ");
      }
      Array.prototype.forEach.call(($("meterSeg") || document).querySelectorAll("[data-v]"), function (b) {
        b.setAttribute("aria-checked", S.product === b.dataset.v ? "true" : "false");
      });
    }

    function renderHeroLadder() {
      /* the compact strip moved out when the full ladder came up under the
         meter; kept as a no-op so a layout that wants it can add the hook back */
      var host = $("heroLadder");
      if (!host) return;
      var P = prod();
      var stops = P.tiers.map(function (t) { return Math.max(t.min, P.minQty); });
      host.innerHTML = P.tiers.map(function (t, i) {
        return '<span class="bkd-hl-step"><b>' + money(t.price) + '</b>' +
               '<i>' + stops[i].toLocaleString() + (i ? "" : " minimum") + '</i></span>';
      }).join('<span class="bkd-hl-arrow" aria-hidden="true">→</span>');
    }

    /* Two groups, not one grid with a badge. The thirty days is a production
       fact, not a marketing problem: somebody choosing Lemon + Honey for a
       June wedding either misses their date or takes a phone call from us,
       and both cost more than the sale. So the lead time is a 19px heading
       over the six, where it cannot be skimmed past — not an 8px corner tag.

       The six still get their photograph and their notes. Hiding them would
       stop the mistake too, but a scent nobody can see is a scent nobody
       orders, and we do not know yet which of them sells. */
    function scentCard(x) {
      var notes = SCENT_NOTES[x.code] || [];
      var img = SCENT_IMG[x.code];
      var on  = S.scentOne === x.code;
      /* Only the chosen card moves. Ten videos on one screen would cost eight
         megabytes and say nothing the stills do not; one costs 800 KB and
         only after somebody has asked for that scent. */
      var vid = on && SCENT_VID[x.code] && !REDUCED.matches;
      var media = !img
        ? '<span class="bkd-scent-img is-plain" aria-hidden="true"></span>'
        : vid
          ? '<span class="bkd-scent-img"><video autoplay muted loop playsinline preload="none"' +
            ' poster="' + CDN + img + '?width=360"' +
            ' aria-label="The materials in ' + esc(x.name) + ', moving">' +
            '<source src="' + VCDN + SCENT_VID[x.code] + '.mp4" type="video/mp4"></video></span>'
          : '<span class="bkd-scent-img"><img loading="lazy" decoding="async" width="360" height="240"' +
            ' src="' + CDN + img + '?width=360" alt="The materials in ' + esc(x.name) + '"></span>';
      return '<button type="button" class="bkd-scent' + (x.lead ? " lead" : "") +
        '" data-v="' + x.code + '" aria-pressed="' + (on ? "true" : "false") + '">' + media +
          '<span class="bkd-scent-code">' + x.code +
            (x.note ? '<b class="bkd-scent-flag">' + esc(x.note) + '</b>' : "") + '</span>' +
          '<span class="bkd-scent-name">' + esc(x.name) + '</span>' +
          '<span class="bkd-scent-notes">' + notes.map(function (n) {
            return '<span class="r"><i>(&nbsp;' + n[0] + '&nbsp;)</i><b>' + esc(n[1]) + '</b></span>';
          }).join("") + '</span>' +
        '</button>';
    }

    /* autoplay+muted is allowed everywhere that matters, but a browser can
       still decline it. Asking once costs nothing and the catch keeps a
       refusal from reaching the console. */
    function nudgePlay(host) {
      var v = host && host.querySelector(".bkd-scent video");
      if (v && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    function wireScentButtons(host) {
      if (!host) return;
      nudgePlay(host);
      Array.prototype.forEach.call(host.querySelectorAll("[data-v]"), function (b) {
        b.onclick = function () {
          S.scentOne = b.dataset.v;
          var sel = $("scentOne"); if (sel) sel.value = S.scentOne;
          renderScentCards(); renderScentWarn(); render();
        };
      });
    }

    function renderScentCards() {
      var host = $("scentCards");
      if (!host) return;
      var stock = SCENTS.filter(function (x) { return !x.lead; });
      var lead  = SCENTS.filter(function (x) { return x.lead; });

      host.innerHTML =
        '<div class="bkd-scent-head"><h3>Poured every week</h3>' +
          '<span>ships in 3 to 5 business days</span></div>' +
        '<div class="bkd-scents">' + stock.map(scentCard).join("") + '</div>';
      wireScentButtons(host);

      var more = $("scentMore");
      if (!more) return;
      more.innerHTML = lead.length
        ? '<div class="bkd-scent-head lead"><h3>Brought in for your run</h3>' +
            '<span>adds about ' + SPECIAL_LEAD_DAYS + ' days</span></div>' +
          '<p class="bkd-sub" style="margin:0 0 10px">We do not keep these in the building. ' +
            'We bring it in for your order, so it ships about a month later than the five above. ' +
            '<b>Pick from those five if your date is tight.</b></p>' +
          '<div class="bkd-scents">' + lead.map(scentCard).join("") + '</div>'
        : "";
      wireScentButtons(more);
    }

    function renderScentWarn() {
      var el = $("scentWarn");
      if (!el) return;
      var sp = specialChosen(S);
      if (!sp.length) { el.classList.add("bkd-hide"); el.innerHTML = ""; return; }
      el.classList.remove("bkd-hide");
      el.innerHTML = "<b>" + esc(sp.map(function (x) { return x.name; }).join(", ")) +
        (sp.length > 1 ? " are special-order scents." : " is a special-order scent.") +
        "</b> We do not keep " + (sp.length > 1 ? "them" : "it") + " in the building, we bring " +
        (sp.length > 1 ? "them" : "it") + " in for your run, which adds about <b>" + SPECIAL_LEAD_DAYS +
        " days</b> before we can ship, on top of the proof. Scents 00 to 04 ship in 3 to 5 business days.";
    }

    /* Three ticks, one job: say the thing is coming later. Each writes its
       own flag and nothing else, and each shows up on the order. */
    [["pickLater", "pickLater"], ["wordsLater", "wordsLater"], ["artLater", "artLater"]].forEach(function (f) {
      var el = $(f[0]);
      if (el) el.onchange = function (e) { S[f[1]] = !!e.target.checked; render(); };
    });

    $("mixOn").onchange = function (e) {
      S.mixOn = e.target.checked;
      $("mixBox").classList.toggle("bkd-hide", !S.mixOn);
      $("singleScent").classList.toggle("bkd-hide", S.mixOn);
      /* This used to spread the whole order across the five stock scents the
         instant the box was ticked, which answered the question for them and
         marked the step finished — one tick and somebody who had read no
         scent at all was through. It opens at nothing assigned now; the
         tally says how many are still to place, and Spread evenly is there
         for anyone who wants the even split as an actual decision. */
      tally();
      renderScentWarn();
      render();
    };
    if ($("mixEven")) $("mixEven").onclick = function () {
      spreadMix(); renderScentWarn(); render();
    };

    /* The quantity someone has actually asked for, floored at the minimum. */
    function askedQty() { var m = prod().minQty; return Math.max(m, Math.floor(S.qty || m)); }
    /* The badge printed it.add flat, so the pink box said "+$1.00 each" at a
       hundred and then cost nothing — the page contradicting itself on the one
       line that promises money. And "Candle only" wore an "included" badge for
       a charge that does not exist. Nothing to add, nothing to say. */
    function priceTag(it, add) {
      if (!it.add) return "";
      return '<span class="bkd-opt-price' + (add === 0 ? " free" : "") + '">' +
        (add === 0 ? "included" : "+" + money(add) + " each") + "</span>";
    }
    function optList(hostKey, items, group, get, set, priceOf) {
      var host = $(hostKey);
      host.innerHTML = items.map(function (it) {
        return '<label class="bkd-opt" data-v="' + it.id + '"><input type="radio" name="' + group + '" value="' + it.id + '"' +
          (get() === it.id ? " checked" : "") + '><span class="bkd-opt-txt"><span class="bkd-opt-name">' + esc(it.name) +
          (priceOf ? priceTag(it, priceOf(it)) : "") +
          '</span><span class="bkd-opt-note">' + esc(it.note) + "</span></span></label>";
      }).join("");
      Array.prototype.forEach.call(host.querySelectorAll("input"), function (i) {
        i.onchange = function () { set(i.value); render(); };
      });
    }
    optList("labelOpts", LABEL_TYPES, "bkd-lbl", function () { return S.labelType; }, function (v) {
      S.labelType = v;

    });
    optList("shipOpts", SHIP_MODES, "bkd-sh", function () { return S.ship; }, function (v) {
      S.ship = v;
      $("oneAddr").classList.toggle("bkd-hide", v !== "one");
      $("manyAddr").classList.toggle("bkd-hide", v !== "many");
      if (v === "many") loadSheetJS();
    });

    ["labelLine", "brandName", "labelNotes", "designLink", "designNote", "cName", "cCo", "cEmail", "cPhone", "cWhen"]
      .forEach(function (key) {
        var el = $(key);
        if (el) el.oninput = function (e) { S[key] = e.target.value; render(); };
      });
    [["aAddr1", "address1"], ["aAddr2", "address2"], ["aCity", "city"], ["aState", "state"], ["aZip", "zip"]]
      .forEach(function (pair) {
        var el = $(pair[0]);
        if (el) el.oninput = function (e) {
          S.address[pair[1]] = pair[1] === "state" ? e.target.value.toUpperCase() : e.target.value;
          render();
        };
      });
    /* ---------------- uploads ---------------- */
    function wireDrop(zoneKey, inputKey, handler) {
      var zone = $(zoneKey), input = $(inputKey);
      zone.onclick = function () { input.click(); };
      zone.onkeydown = function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); input.click(); } };
      zone.ondragover = function (e) { e.preventDefault(); zone.classList.add("over"); };
      zone.ondragleave = function () { zone.classList.remove("over"); };
      zone.ondrop = function (e) {
        e.preventDefault(); zone.classList.remove("over");
        if (e.dataTransfer.files[0]) handler(e.dataTransfer.files[0]);
      };
      input.onchange = function (e) { if (e.target.files[0]) handler(e.target.files[0]); };
    }
    function shrink(file, cb) {
      var r = new FileReader();
      if (file.type === "image/svg+xml") { r.onload = function () { cb(r.result); }; r.readAsDataURL(file); return; }
      r.onload = function () {
        var img = new Image();
        img.onload = function () {
          var max = 1200, sc = Math.min(1, max / Math.max(img.width, img.height));
          var cv = document.createElement("canvas");
          cv.width = Math.round(img.width * sc); cv.height = Math.round(img.height * sc);
          var cx = cv.getContext("2d");
          cx.fillStyle = "#ffffff"; cx.fillRect(0, 0, cv.width, cv.height);
          cx.drawImage(img, 0, 0, cv.width, cv.height);
          cb(cv.toDataURL("image/jpeg", 0.85));
        };
        img.onerror = function () { cb(r.result); };
        img.src = r.result;
      };
      r.readAsDataURL(file);
    }
    function showLogo() {
      var box = $("logoGot");
      if (!S.logo) { box.classList.add("bkd-hide"); return; }
      box.classList.remove("bkd-hide");
      box.innerHTML = '<div class="bkd-logo"><img src="' + S.logo.dataUrl + '" alt="Your logo"><div class="meta">' +
        '<div class="fn">' + esc(S.logo.name) + '</div><div class="fs">' + Math.round(S.logo.size / 1024) +
        " KB · " + (S.logo.tooBigForOriginal
          ? "too large to send as-is, so we will ask for the original by email"
          : (S.logo.original ? "original kept for printing" : "reading…")) +
        '</div></div>' +
        '<button class="bkd-link" type="button" data-rm="1">Remove</button></div>';
      box.querySelector("[data-rm]").onclick = function () { S.logo = null; showLogo(); render(); };
    }
    wireDrop("logoDrop", "logoInput", function (f) {
      /* Two copies on purpose. The shrunken one is for the thumbnail on this
         page; the ORIGINAL is what gets stored and printed from. A logo
         flattened to a 1200px JPEG on a white ground is not a printable file —
         the transparency is gone and the edges are mush. */
      shrink(f, function (url) {
        S.logo = { name: f.name, size: f.size, dataUrl: url, type: f.type };
        showLogo(); render();
        var MAX_ORIGINAL = 2800000;          /* the worker takes ~2.9 MB once base64'd */
        if (f.size > MAX_ORIGINAL) { S.logo.tooBigForOriginal = true; showLogo(); return; }
        var fr = new FileReader();
        fr.onload = function () { S.logo.original = fr.result; showLogo(); };
        fr.readAsDataURL(f);
      });
    });

    /* ---------------- address list ---------------- */
    var sheetPromise = null;
    function loadSheetJS() {
      if (sheetPromise) return sheetPromise;
      sheetPromise = new Promise(function (res, rej) {
        if (window.XLSX) return res(window.XLSX);
        var s = document.createElement("script");
        s.src = SHEETJS;
        s.onload = function () { res(window.XLSX); };
        s.onerror = function () { rej(new Error("sheetjs")); };
        document.head.appendChild(s);
      });
      return sheetPromise;
    }
    var COLMAP = [
      ["name",    ["recipient", "recipient name", "name", "full name", "to", "ship to", "contact"]],
      ["company", ["company", "organization", "org", "business", "firm"]],
      ["addr",    ["address", "address 1", "address1", "street", "addr", "line 1", "address line 1"]],
      ["addr2",   ["address 2", "address2", "apt", "suite", "unit", "line 2", "address line 2"]],
      ["city",    ["city", "town"]],
      ["state",   ["state", "province", "region", "st"]],
      ["zip",     ["zip", "zip code", "postal", "postal code", "postcode", "zipcode"]],
      ["country", ["country"]],
      ["qty",     ["qty", "quantity", "candles", "count", "units", "#"]],
      ["scent",   ["scent", "fragrance", "smell"]],
      ["label",   ["label", "label text", "personalization", "message on label", "custom text"]]
    ];
    function mapRow(rawRow) {
      var out = {}, keys = Object.keys(rawRow);
      COLMAP.forEach(function (pair) {
        var field = pair[0], names = pair[1];
        var hit = keys.filter(function (k) { return names.indexOf(String(k).trim().toLowerCase()) !== -1; })[0];
        if (hit != null && rawRow[hit] !== "" && rawRow[hit] != null) out[field] = String(rawRow[hit]).trim();
      });
      if (out.addr2) out.addr = (out.addr || "") + ", " + out.addr2;
      out.qty = Math.max(1, Math.floor(+out.qty || 1));
      return out;
    }
    function readSheet(file) {
      loadSheetJS().then(function (XLSX) {
        var r = new FileReader();
        r.onload = function (e) {
          var rows = [];
          try {
            var wb = XLSX.read(e.target.result, { type: "array" });
            rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" });
          } catch (err) { rows = []; }
          if (!rows.length) {
            $("xlOut").innerHTML = '<div class="bkd-note"><b>We could not read that file.</b> Make sure the first row ' +
              "is the column headings and there is at least one row of addresses under it. The blank template above " +
              "has the layout we expect.</div>";
            return;
          }
          S.rows = rows.map(mapRow).filter(function (x) { return x.name || x.addr || x.company; });
          var sum = S.rows.reduce(function (a, x) { return a + (x.qty || 1); }, 0);
          if (sum > 0) { setQty(sum); }
          showRows(file.name);
          render();
        };
        r.readAsArrayBuffer(file);
      }).catch(function () {
        $("xlOut").innerHTML = '<div class="bkd-note"><b>The spreadsheet reader could not load.</b> ' +
          "Save your list as a .csv and try again, or email it to us with your quote.</div>";
      });
    }
    function showRows(fname) {
      var c = compute();
      var each = (c.unit === null ? c.P.tiers[c.P.tiers.length - 1].price : c.unit) + packAdd(c.pk, c.q);
      var head = ["Recipient", "Company", "Address", "City", "State", "ZIP", "Qty", "Scent", "Label", "Ship"];
      var body = S.rows.slice(0, 60).map(function (r) {
        var paid = (r.qty || 1) * each < CFG.freeShipOver;
        return "<tr><td>" + esc(r.name || "-") + "</td><td>" + esc(r.company || "") + "</td><td>" + esc(r.addr || "") +
          "</td><td>" + esc(r.city || "") + "</td><td>" + esc(r.state || "") + "</td><td>" + esc(r.zip || "") +
          '</td><td class="n">' + (r.qty || 1) + "</td><td>" + esc(r.scent || "") + "</td><td>" + esc(r.label || "") +
          '</td><td class="n' + (paid ? " warn" : "") + '">' + (paid ? money(CFG.perPackageShip) : "free") + "</td></tr>";
      }).join("");
      var missing = S.rows.filter(function (r) { return !r.addr || !r.city || !r.zip; }).length;
      $("xlOut").innerHTML = '<div class="bkd-tblwrap"><table><thead><tr>' +
        head.map(function (h) { return "<th>" + h + "</th>"; }).join("") + "</tr></thead><tbody>" + body +
        '</tbody></table></div><div class="bkd-tblnote">Read <b>' + S.rows.length.toLocaleString() +
        " recipients</b> from " + esc(fname) + " · " +
        S.rows.reduce(function (a, r) { return a + (r.qty || 1); }, 0).toLocaleString() + " candles total" +
        (S.rows.length > 60 ? " · showing the first 60" : "") +
        (missing ? ' · <span style="color:var(--rust)"><b>' + missing + "</b> rows are missing part of the " +
          "address. We will come back to you on those</span>" : "") + "</div>";
    }
    wireDrop("xlDrop", "xlInput", readSheet);

    /* ---------------- files, clipboard, send ---------------- */
    function saveFile(filename, text, mime) {
      try {
        var b = new Blob([text], { type: mime || "text/plain" });
        var a = document.createElement("a");
        a.href = URL.createObjectURL(b); a.download = filename;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
        return true;
      } catch (e) { return false; }
    }
    function toast(msg) {
      var t = document.createElement("div");
      t.className = "bkd-toast"; t.textContent = msg;
      document.body.appendChild(t);
      setTimeout(function () { t.remove(); }, 3000);
    }
    function cell(v) {
      var s = String(v == null ? "" : v);
      return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    }

    $("dlTemplate").onclick = function () {
      var head = ["Recipient Name", "Company", "Address 1", "Address 2", "City", "State", "ZIP", "Country", "Qty", "Scent", "Label Text"];
      var sample = ["Dana Reyes", "Northgate Realty", "1400 Harbor Blvd", "Suite 210", "Costa Mesa", "CA", "92626", "US", "1", "03", "Congratulations on the new place"];
      saveFile("james-wax-address-template.csv", head.join(",") + "\n" + sample.map(cell).join(",") + "\n", "text/csv");
      toast("Template downloaded");
    };
    $("csvBtn").onclick = function () {
      if (!S.rows.length) { toast("Upload an address list first"); return; }
      var head = ["Recipient Name", "Company", "Address", "City", "State", "ZIP", "Country", "Qty", "Scent", "Label Text"];
      var csv = [head.join(",")].concat(S.rows.map(function (r) {
        return [r.name, r.company, r.addr, r.city, r.state, r.zip, r.country || "US", r.qty || 1, r.scent || "", r.label || ""].map(cell).join(",");
      })).join("\n");
      saveFile("james-wax-addresses.csv", csv, "text/csv");
      toast("Address CSV downloaded");
    };
    $("copyBtn").onclick = function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(SPEC).then(function () { toast("Spec copied. Paste it into an email to us"); },
          function () { toast("Select the text below and copy it"); });
      } else { toast("Select the text below and copy it"); }
    };
    /* A box the buyer is being CHARGED for has to exist as a product, or the
       cart quietly bills for candles alone while the order still tells the
       studio to pack boxes. That is not an inconvenience, it is us giving away
       a dollar a candle and never seeing it. A free box needs no product. */
    function boxReady(c) {
      return !(c.pk.id !== "none" && packAdd(c.pk, c.q) > 0 && !VARIANTS[BOX_HANDLE]);
    }
    /* The first version of this asked for the name, the email and the whole
       address before it would let anyone check out, and that was wrong twice
       over: Shopify’s own checkout collects all of it on the very next
       screen, and blocking the button to collect it here just stopped people
       buying. It is gone.

       What checkout will never ask is what to print. That rides on the cart
       as a line-item property and there is no later screen that catches it —
       an order that arrives without it is a hundred candles we cannot pour
       and an email to the customer asking what they meant. So that, and only
       that, is what holds the button. */
    /* What each route genuinely needs, which is not always the asset itself.
       Somebody ordering before they can lay hands on the print file, or still
       arguing with their partner about the wording, is a customer, not an
       incomplete form. Each route therefore takes either the thing or a
       statement of when it is coming, and the statement rides on the order so
       the studio knows to wait rather than to chase. */
    function missingRequired() {
      var t = S.labelType;
      if (t === "text")
        return (String(S.labelLine || "").trim() || S.wordsLater) ? []
          : [["labelLine", "the words for the label, or a tick to say they are coming"]];
      if (t === "logo")
        return (S.logo || S.artLater) ? []
          : [["logoDrop", "your artwork, or a tick to say you will email it"]];
      if (t === "catalog")
        return (String(S.designLink || "").trim() || String(S.designNote || "").trim() || S.pickLater) ? []
          : [["designLink", "a link, a description, or a tick to say you want options"]];
      return [];
    }

    /* The label details do hold the button, because an order without them is
       one we cannot pour. What went wrong the first two times was not the
       rule, it was the dead end: the button vanished on a page nobody had
       touched yet, with no way forward from it.

       So the button never disappears. When the label is not filled in it
       says what to do next and goes there. Three states, one control. */
    function labelReady() { return !missingRequired().length; }

    /* What each step needs before it counts as done. The tick in the rail
       used to mean "you have walked past this", which is not the same thing
       and let an order reach the cart with three of four steps untouched.
       Each entry returns the gap it has, so one routine can say which step
       is unfinished, what is missing from it, and where to put the cursor. */
    function stepGap(i) {
      var a = S.address;
      if (i === 0) {
        if (S.mixOn) {
          var t = mixTotal();
          return t === S.qty ? null
            : { hook: "mix", what: "all " + S.qty.toLocaleString() + " candles assigned to a scent" };
        }
        return scentByCode(S.scentOne) ? null : { hook: "scentCards", what: "a scent" };
      }
      if (i === 1) {
        var m = missingRequired();
        return m.length ? { hook: m[0][0], what: m[0][1] } : null;
      }
      if (i === 2) {
        if (S.ship === "many")
          return S.rows.length ? null : { hook: "xlDrop", what: "your address list" };
        if (!String(a.address1 || "").trim()) return { hook: "aAddr1", what: "a street address" };
        if (!String(a.city || "").trim())     return { hook: "aCity",  what: "a city" };
        if (!String(a.state || "").trim())    return { hook: "aState", what: "a state" };
        if (!String(a.zip || "").trim())      return { hook: "aZip",   what: "a ZIP" };
        return null;
      }
      if (i === 3) {
        if (!String(S.cName || "").trim())  return { hook: "cName",  what: "your name" };
        var e = String(S.cEmail || "").trim();
        if (!e || e.indexOf("@") < 1)       return { hook: "cEmail", what: "an email we can send the proof to" };
        return null;
      }
      return null;
    }
    function stepDone(i) { return !stepGap(i); }
    function firstGap() {
      for (var i = 0; i < STEP_NAMES.length; i++) { var g = stepGap(i); if (g) { g.step = i; return g; } }
      return null;
    }
    /* Refusing to move on is only half of it — the other half is standing them
       in front of the box that is empty. Used by Next, by the step tabs and by
       the cart button, so all three refuse the same way. */
    function showGap(gap) {
      if (!gap) return;
      var el = $(gap.hook);
      var sec = el && el.closest("[data-bkd='step']");
      if (sec) goStep(+sec.dataset.step);
      setTimeout(function () {
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        if (el.focus) el.focus();
        el.classList.add("bkd-err");
        setTimeout(function () { el.classList.remove("bkd-err"); }, 2200);
      }, 80);
    }

    function payable(c) {
      return Boolean(VARIANTS[c.P.handle]) && boxReady(c) && !c.byQuote &&
             S.ship === "one" && !firstGap();
    }

    function whyNotPayable(c) {
      if (!VARIANTS[c.P.handle]) return null;              /* products not built yet */
      if (!boxReady(c)) return "We cannot take the " + esc(c.pk.name.toLowerCase()) +
        " through checkout yet. Send the quote instead and we’ll invoice it with the boxes on it, " +
        "or choose candle only, which checks out now.";
      if (c.byQuote) return "Orders this size we price by hand. Freight and a production date " +
        "both need a conversation. Send the spec and we’ll come back with a firm number.";
      if (S.ship === "many") return "Shipping to many recipients is quoted per package rather than " +
        "estimated, so this one comes to us first. Everything else about your order is already set.";
      return null;
    }

    /* Still used by the emailed quote, not by checkout — the cart prices the
       order now, and Shopify’s own discounts decide the money. */
    function payload(c) {
      return {
        product: S.product,
        qty: c.q, mixOn: S.mixOn, mix: S.mix, scentOne: S.scentOne,
        labelType: S.labelType, labelLine: S.labelLine, brandName: S.brandName, labelNotes: S.labelNotes,
        logoDataUrl: S.logo ? S.logo.dataUrl : null,
        pack: S.pack,
        ship: S.ship, address: S.address,
        cName: S.cName, cCo: S.cCo, cEmail: S.cEmail, cPhone: S.cPhone, cWhen: S.cWhen
      };
    }

    /* Variant ids, read off Shopify at run time rather than pasted into a theme
       setting. Rebuilding the scents in the admin then costs nothing here. */
    var VARIANTS = {};
    function loadVariants(handle) {
      if (!handle || VARIANTS[handle] !== undefined) return Promise.resolve();
      VARIANTS[handle] = null;
      return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants || !p.variants.length) return;
          var byCode = {};
          p.variants.forEach(function (v) {
            /* match on the scent code we print on the label — "01", "02" … —
               wherever it appears in the variant title */
            var m = String(v.title || "").match(/\b(\d{2})\b/);
            if (m) byCode[m[1]] = v.id;
            byCode[String(v.title || "").toLowerCase()] = v.id;
          });
          VARIANTS[handle] = { first: p.variants[0].id, byCode: byCode, available: p.available };
          render();
        })
        .catch(function () {});
    }

    function variantFor(handle, scentCode) {
      var v = VARIANTS[handle];
      if (!v) return null;
      return v.byCode[scentCode] || v.first;
    }

    /* Everything the studio needs that is not quantity or price rides along as
       line item properties, so it lands on the order and the packing slip. */
    /* The scent has to ride on the line. Both bulk products carry a single
       variant, so variantFor falls back to it for every code and the scent
       would otherwise reach the studio nowhere at all — on an order the whole
       page exists to take without a single email. A mixed order also needs one
       line per scent, and since the variant id is shared, it is these
       properties that keep them apart. */
    function lineProps(c, scent) {
      var lt = labelType();
      var props = {};
      if (scent) {
        props["Scent"] = scent.code + " " + scent.name;
        if (scent.lead) props["Lead time"] = "special order, +" + scent.lead + " days";
      }
      props["Label"] = lt.name || S.labelType;
      if (S.labelType === "catalog") {
        if (S.designLink) props["Design link"] = S.designLink;
        if (S.designNote) props["Design"] = S.designNote;
        if (S.pickLater && !S.designLink && !S.designNote)
          props["Design"] = "Not chosen yet, send options with the proof";
      }
      if (S.labelType === "text" && S.wordsLater && !S.labelLine)
        props["Printed text"] = "To follow by email";
      if (S.labelType === "logo" && S.artLater && !S.logo)
        props["Artwork"] = "To follow by email";
      if (S.labelType === "text" && S.labelLine) props["Printed text"] = S.labelLine;
      if (S.labelType === "logo") {
        if (S.brandName) props["Brand"] = S.brandName;
        if (S.labelNotes) props["Artwork notes"] = S.labelNotes;
        if (S.logo) props["Artwork file"] = S.logo.name;
      }
      if (S.cCo) props["Company"] = S.cCo;
      if (S.cWhen) props["Needed by"] = S.cWhen;
      props["Tier"] = money(c.unit) + " each at " + c.q.toLocaleString();
      return props;
    }

    function cartItems(c) {
      var items = [], handle = c.P.handle;
      var split = S.mixOn
        ? SCENTS.map(function (x) { return { code: x.code, n: Math.floor(S.mix[x.code] || 0) }; })
                .filter(function (x) { return x.n > 0; })
        : [{ code: S.scentOne, n: c.q }];
      split.forEach(function (part) {
        var id = variantFor(handle, part.code);
        if (id) items.push({ id: id, quantity: part.n,
                             properties: lineProps(c, scentByCode(part.code)) });
      });
      /* The box is its own product on purpose: inside the discount’s scope it
         would be discounted AND would count toward the quantity threshold. */
      if (c.pk.id !== "none") {
        if (packAdd(c.pk, c.q) > 0) {
          /* Paid. payable() has already refused checkout if this variant is
             missing, so reaching here without one is a bug worth failing on
             rather than papering over with an "(included)" we never billed. */
          var boxId = VARIANTS[BOX_HANDLE] && variantFor(BOX_HANDLE, c.P.id === "tin4" ? "04" : "09");
          if (!boxId) throw new Error("The " + c.pk.name.toLowerCase() + " is not set up to sell yet.");
          items.push({ id: boxId, quantity: c.q, properties: { "For": c.P.name } });
        } else {
          /* Genuinely free at this quantity, so there is nothing to charge —
             but the studio still has to know to pack one. */
          items.forEach(function (it) { it.properties["Packaging"] = c.pk.name + " (included)"; });
        }
      }
      return items;
    }

    /* Park the artwork and the address list somewhere Jin can actually open
       them, and put the links on the order. Without this the cart carries a
       filename and nothing else. */
    async function stash(dataUrl) {
      if (!CFG.orderEndpoint || !dataUrl) return null;
      try {
        var res = await fetch(CFG.orderEndpoint.replace(/\/$/, "") + "/art", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: dataUrl })
        });
        if (!res.ok) return null;
        var body = await res.json();
        return body && body.url ? body.url : null;
      } catch (e) { return null; }
    }

    function addressesAsDataUrl() {
      if (!S.rows.length) return null;
      var head = ["Recipient Name", "Company", "Address", "City", "State", "ZIP", "Country", "Qty", "Scent", "Label Text"];
      var csv = [head.join(",")].concat(S.rows.map(function (r) {
        return [r.name, r.company, r.addr, r.city, r.state, r.zip, r.country || "US",
                r.qty || 1, r.scent || "", r.label || ""].map(cell).join(",");
      })).join("\n");
      return "data:text/csv;base64," + btoa(unescape(encodeURIComponent(csv)));
    }

    var paying = false;
    async function pay() {
      if (paying) return;
      var c = compute();
      if (!payable(c)) return;
      var items = cartItems(c);
      if (!items.length) {
        showPayNote("We could not match your scent to a product just now. Send the spec " +
          "instead and we’ll invoice you. Nothing has been charged.", true);
        return;
      }

      paying = true;
      var btn = $("payBtn"), was = btn.textContent;
      btn.textContent = "Adding to your cart…"; btn.disabled = true;
      try {
        /* do this before the cart add: an order that reaches Jin without the
           artwork is worse than one that does not reach him at all */
        var artUrl = S.logo ? await stash(S.logo.original || S.logo.dataUrl) : null;
        var listUrl = S.ship === "many" ? await stash(addressesAsDataUrl()) : null;
        if (artUrl || listUrl) {
          items.forEach(function (it) {
            if (artUrl) it.properties["Artwork"] = artUrl;
            if (listUrl) it.properties["Address list"] = listUrl;
          });
        }
        if (S.logo && !artUrl) {
          showPayNote("We could not attach your artwork just now, so we have not added this to " +
            "your cart. Send the spec instead and we’ll pick the file up from your reply.", true);
          return;
        }
        var res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        });
        if (res.ok) { window.location.href = "/cart"; return; }
        var body = await res.json().catch(function () { return {}; });
        showPayNote((body && body.description) || "We could not add this to your cart just now. " +
          "Send the spec instead and we’ll invoice you. Nothing has been charged.", true);
      } catch (e) {
        showPayNote("We could not reach the cart. Send the spec instead and we’ll invoice " +
          "you. Nothing has been charged.", true);
      } finally {
        paying = false; btn.textContent = was; btn.disabled = false;
      }
    }
    function showPayNote(msg, warn) {
      var el = $("payNote");
      el.classList.remove("bkd-hide");
      el.style.borderLeftColor = warn ? "var(--rust)" : "var(--gold)";
      el.innerHTML = msg;
    }

    function send() {
      var c = compute();
      var subj = "Bulk order: " + (S.cCo || S.cName || "new enquiry") + ", " + c.q.toLocaleString() +
                 " candles (" + c.tier.name + ")";
      var url = "mailto:" + CFG.email + "?subject=" + encodeURIComponent(subj) +
                "&body=" + encodeURIComponent((SPEC + "\n\nSent from the James Wax bulk desk").slice(0, 1800));
      window.location.href = url;
      setTimeout(function () {
        /* mailto only opens a draft. Saying "sent" here would be the one place
           on the page where a click looks like it reached us and did not. */
        toast("<b>We opened a draft in your mail app, you still need to send it.</b> " +
              (S.logo ? "Attach your artwork file. " : "") +
              (S.ship === "many" ? "Attach your address list. " : "") +
              "If nothing opened, use <b>Copy the full spec</b> and mail it to " + CFG.email + ".");
      }, 1200);
    }
    $("sendBtn").onclick = send;
    $("payBtn").onclick = pay;
    $("railSend").onclick = function () {
      var c = compute();
      var gap = firstGap();
      /* Not ready is not an error, it is the next step. Go to the box that
         is empty rather than leaving somebody looking for it. */
      if (gap && !c.byQuote && S.ship === "one") { showGap(gap); return; }
      $("sendBtn").scrollIntoView({ behavior: "smooth", block: "center" });
      if (payable(c)) { pay(); } else { send(); }
    };

    /* ---------------- profile ---------------- */
    var KEY = "jameswax.bulkdesk.profile.v1";
    var FIELDS = ["product", "cName", "cCo", "cEmail", "cPhone", "cWhen", "labelType", "labelLine", "brandName", "labelNotes", "designLink", "designNote",
      /* the three "it is coming later" ticks. Without these a saved profile
         came back with the boxes clear but the order still counted as
         answered, or the reverse: the state and what is on screen have to
         travel together or one of them is lying. */
      "pickLater", "wordsLater", "artLater",
                  "pack", "ship", "address", "scentOne", "logo", "rows"];
    function profileObj() {
      var o = {};
      FIELDS.forEach(function (k) { o[k] = S[k]; });
      /* The print-resolution original is megabytes; localStorage is about five
         in total, so saving it would throw the quota and lose the whole
         profile. The thumbnail is enough to show them what they picked, and
         the file itself lives on the order once they check out. */
      if (o.logo && o.logo.original) {
        o.logo = { name: o.logo.name, size: o.logo.size, type: o.logo.type, dataUrl: o.logo.dataUrl };
      }
      o._saved = new Date().toISOString();
      return o;
    }
    function noteProfile(when) {
      $("profileNote").innerHTML = when
        ? "<b>Your details are saved on this device.</b> Last saved " + new Date(when).toLocaleString("en-US") +
          ". Next time you open this page it fills itself in. Use <b>Export profile file</b> to move it to another " +
          "computer or send it to a colleague."
        : "<b>Nothing saved yet.</b> Save your details and this page will remember your logo, your packaging choice " +
          "and your address list, so a reorder takes about ten seconds.";
    }
    function applyProfile(o) {
      FIELDS.forEach(function (k) { if (o[k] !== undefined) S[k] = o[k]; });
      /* "photo" and "logo" used to be separate options; a profile saved then
         would otherwise restore to a label type that no longer exists. */
      if (S.labelType === "photo") S.labelType = "logo";
      ["cName", "cCo", "cEmail", "cPhone", "cWhen", "labelLine", "brandName", "labelNotes", "designLink", "designNote"]
        .forEach(function (k) { if ($(k)) $(k).value = S[k] || ""; });
      if (!S.address) S.address = { address1: "", address2: "", city: "", state: "", zip: "", country: "US" };
      [["aAddr1", "address1"], ["aAddr2", "address2"], ["aCity", "city"], ["aState", "state"], ["aZip", "zip"]]
        .forEach(function (pr) { if ($(pr[0])) $(pr[0]).value = S.address[pr[1]] || ""; });
      ["pickLater", "wordsLater", "artLater"].forEach(function (k) {
        if ($(k)) $(k).checked = !!S[k];
      });
      $("scentOne").value = S.scentOne;
      ["bkd-prod", "bkd-lbl", "bkd-pk", "bkd-sh"].forEach(function (g, i) {
        var val = [S.product, S.labelType, S.pack, S.ship][i];
        Array.prototype.forEach.call(root.querySelectorAll('input[name="' + g + '"]'), function (inp) {
          inp.checked = inp.value === val;
        });
      });

      $("oneAddr").classList.toggle("bkd-hide", S.ship !== "one");
      $("manyAddr").classList.toggle("bkd-hide", S.ship !== "many");
      showLogo();
      renderProductPicker(); renderChips(); renderPackaging();
      if ($("qtyMin")) $("qtyMin").textContent = "(" + prod().minQty + " minimum)";
      if (S.rows && S.rows.length) { loadSheetJS(); showRows("your saved list"); }
      render();
      noteProfile(o._saved);
    }
    $("saveProfile").onclick = function () {
      try {
        localStorage.setItem(KEY, JSON.stringify(profileObj()));
        noteProfile(new Date().toISOString());
        toast("Saved on this device");
      } catch (e) { toast("This browser is blocking storage. Use Export profile file instead"); }
    };
    $("exportProfile").onclick = function () {
      saveFile("james-wax-profile.json", JSON.stringify(profileObj(), null, 2), "application/json");
      toast("Profile exported");
    };
    $("importProfile").onclick = function () { $("profileInput").click(); };
    $("profileInput").onchange = function (e) {
      var f = e.target.files[0];
      if (!f) return;
      var r = new FileReader();
      r.onload = function () {
        try { applyProfile(JSON.parse(r.result)); toast("Profile loaded"); }
        catch (err) { toast("That file wasn’t a James Wax profile"); }
      };
      r.readAsText(f);
    };
    $("clearProfile").onclick = function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      noteProfile(null);
      toast("Saved details cleared from this device");
    };

    /* ---------------- steps ---------------- */
    /* Six headings on one scroll gave no sense of how much was left, and let
       someone reach the pay button having skipped the label they came for.
       One step at a time, with every step still reachable from the nav — this
       is a configurator, not a form to be policed. */
    var STEP_NAMES = ["Scent", "Make it yours", "Delivery", "Review & pay"];
    /* A phone cannot hold "Make it yours" and "Review & pay" in four equal
       columns, and a rail that scrolls sideways hides the steps you have not
       reached. Short names on small screens, the real ones everywhere else. */
    var STEP_SHORT = ["Scent", "Label", "Ship", "Pay"];
    var stepEls = Array.prototype.slice.call(root.querySelectorAll('[data-bkd="step"]'));

    /* Redrawn whenever anything changes, not only when the step changes:
       the ticks now mean "finished", and finishing happens inside a step, so
       waiting for a navigation to repaint them left them lying. Cheap, and
       skipped entirely when the pattern is the same as last time. */
    var navSig = "";
    function renderStepNav() {
      var sig = S.step + "|" + STEP_NAMES.map(function (_, i) { return stepDone(i) ? "1" : "0"; }).join("");
      if (sig === navSig) return;
      navSig = sig;
      $("stepNav").innerHTML = STEP_NAMES.map(function (name, i) {
        var done = stepDone(i);
        var cls = (i === S.step ? "is-current" : "") + (done ? " is-done" : "");
        var mark = done ? "&#10003;" : String(i + 1).padStart(2, "0");
        return '<button type="button" class="' + cls + '" data-step-to="' + i + '"' +
          (i === S.step ? ' aria-current="step"' : "") + "><b>" + mark + "</b>" +
          '<span class="lg">' + esc(name) + '</span>' +
          '<span class="sm">' + esc(STEP_SHORT[i] || name) + "</span></button>";
      }).join("");
      Array.prototype.forEach.call($("stepNav").querySelectorAll("button"), function (b) {
        b.onclick = function () { tryStep(+b.dataset.stepTo); };
      });
    }

    function goStep(i) {
      S.step = Math.max(0, Math.min(STEP_NAMES.length - 1, i));
      stepEls.forEach(function (el) {
        el.classList.toggle("is-active", +el.dataset.step === S.step);
      });
      renderStepNav();
      if (typeof render === "function") render();
      var last = S.step === STEP_NAMES.length - 1;
      $("stepBack").classList.toggle("bkd-hide", S.step === 0);
      $("stepNext").classList.toggle("bkd-hide", last);
      if (!last) {
        /* what the next step will ask for, so pressing it is a decision and
           not a leap */
        var PROMISE = ["what goes on the label", "where it is going", "your details and payment"];
        $("stepNextLabel").textContent = STEP_NAMES[S.step + 1] + " \u2192";
        $("stepNextSub").textContent = PROMISE[S.step] || "";
      }
      if ($("stepWhere")) $("stepWhere").textContent =
        "Step " + (S.step + 1) + " of " + STEP_NAMES.length;
      /* scroll the nav back into view, not the top of the document — the header
         is tall and jumping to it hides the step they just landed on */
      var nav = $("stepNav");
      if (nav && nav.getBoundingClientRect().top < 0) nav.scrollIntoView({ block: "start" });
    }

    /* How far they have actually got. Pressing Next twice used to walk
       straight over an empty label or an empty address, because only the cart
       button ever checked. Next checks now, and so does a tab — but only when
       the tab goes somewhere new. A step already reached stays reachable, so
       going back to reword a label does not strand you behind your own edit. */
    var reached = 0;
    function tryStep(i) {
      if (i > reached) {
        var g = firstGap();
        if (g && g.step < i) { showGap(g); return; }
      }
      reached = Math.max(reached, i);
      goStep(i);
    }

    $("stepBack").onclick = function () { goStep(S.step - 1); };
    $("stepNext").onclick = function () {
      var g = stepGap(S.step);
      /* Standing on the step it is missing from: the note under the box
         already says what is wanted, so just put the cursor in it. */
      if (g) { showGap(g); return; }
      tryStep(S.step + 1);
    };

    /* ---------------- boot ---------------- */
    renderProductPicker(); renderChips(); renderPackaging();
    if ($("qtyMin")) $("qtyMin").textContent = "(" + prod().minQty + " minimum)";
    /* Ask Shopify what the variants are. Until this lands the page prices and
       specs fine, it just cannot put anything in a cart — which is also the
       correct state before the products exist. */
    PRODUCTS.forEach(function (p) { loadVariants(p.handle); });
    loadVariants(BOX_HANDLE);
    goStep(0);

    var saved = null;
    try { var s = localStorage.getItem(KEY); if (s) saved = JSON.parse(s); } catch (e) {}
    if (saved) { applyProfile(saved); } else { noteProfile(null); render(); }

    if (CFG.orderEndpoint) {
      fetch(CFG.orderEndpoint.replace(/\/$/, "") + "/pricing")
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.products) return;
          adoptRemote(j);
          renderProductPicker(); renderChips(); renderPackaging();
          if ($("qtyMin")) $("qtyMin").textContent = "(" + prod().minQty + " minimum)";
          render();
        })
        .catch(function () { /* the shipped copy of the ladder stands */ });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(".bkd"), boot);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
